import { Guid } from './Shared';

export interface LoanApplicationTask {
	guid: Guid;
	applicationTaskTitle: string;
	collectionIndex: number | null;
	notApplicable: boolean;
	displayOrder: number | null;
	completedOn: Date | null;
	completedBy: string | null;
	status: ApplicationTaskStatusType;
	documents: LoanApplicationTaskDocument[];
	createdOn: string;
	summary: string;
	loanApplicationDisplayOrder: number;
	statusValue: number;
	templateFileName: string;
	template: LoanApplicationTaskTemplate;
	hasTemplate: boolean;
	isCustomExampleFile: boolean;
}

export type ApplicationTaskStatusType = keyof typeof ApplicationTaskStatusTypeMap;
export const ApplicationTaskStatusTypeMap = {
	Pending: 'Pending',
	InProgress: 'In Progress',
	Completed: 'Completed',
	NotApplicable: 'N/A',
};

export interface LoanApplicationTaskDocument {
	guid: Guid;
	documentTitle: string;
	fileName: string;
	createdOn: Date;
	fileSize: number;
}

export interface LoanApplicationTaskTemplate {
	guid: Guid;
	title: string;
	displayOrder: number;
	isLoanApplicationDefault: boolean;
	isCustomFolder: boolean;
	templateFileName: string;
}

export interface CreateRequiredDocumentDto {
	taskType: Guid;
	title: string;
}

export interface UpdateLoanApplicationTaskDto {
	updateType: UpdateLoanApplicationTaskType;
	notApplicable: boolean;
	uploads: File[];
}

export interface EditLoanApplicationTaskDto {
	updateType: UpdateLoanApplicationTaskType;
	applicationTaskTitle: string;
	summary: string;
	removeUploadedFile: boolean;
}

export interface UploadLoanApplicationFilesDto {
	uploads: File[];
}

export type UpdateLoanApplicationTaskType = keyof typeof UpdateLoanApplicationTaskTypeMap;
export const UpdateLoanApplicationTaskTypeMap = {
	MarkNa: 'Mark N/A',
	ClearNa: 'Clear N/A',
	Upload: 'Upload',
	Edit: 'Edit',
	Completed: 'Completed',
};
